import { Add, Cancel, CheckCircle, Link as LinkIcon, OpenInNew as OpenInNewIcon, Remove } from '@mui/icons-material';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, styled } from '@mui/material';
import dayjs from "dayjs";
import React, { useCallback, useReducer } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Swal from "sweetalert2";
import { debounce } from 'throttle-debounce';
import { VhpSterilizerTable } from '../../AppGrid/SterilizerCycleTable';
import strings from '../../Globalization';
import ActionIconButton from '../../components/common/ActionIconButton';
import LoadingDialog from '../../components/common/LoadingDialog';
import consts from '../../consts';
import Model from '../../models/model';
import connectionService from '../../services/Connection';
import util from '../../util';
import dateUtil from '../../util/dateUtil';

const errorFormKeysToDelete = ['ReusableTestPackId', 'Implant', 'Test', 'SterilizerCycleTypeName', 'SterilizerCycleCount', 'RunById', 'MaxTemp', 'MinTemp', 'LoadNumber', 'CIReadById', 'CILotNumberId', 'BIReadById']
const isNoneType = [consts.EquipmentFamilyType.NONSTERISSTEAM, consts.EquipmentFamilyType.NONSTERISHP]
const { regex } = consts;

const SterilizerCycleTable = VhpSterilizerTable.createGridBase();
let isDesktop = util.getPlatform() === null;
let intialConfig = { LoadNumber: '', SterilizerMachineLength: 0, SterilizerCycleNumberLength: 0, DateFormat: '', SplitChar: '' };
const getLoadDateFormat = ({ LoadNumber, intialConfig, utilLoadNumberFormat, utitagsLoadNumberFormat }) => {
	if (util.localData.loginData.tags) {
		let loadNumExist = false;
		if (LoadNumber) {
			loadNumExist = true;
		}
		let loadNumberFormat = utilLoadNumberFormat?.LoadNumberFormat ? utilLoadNumberFormat.split('/') : utitagsLoadNumberFormat.split('/');
		loadNumberFormat.forEach(value => {
			switch (value) {
				case 'M2':
				case 'M3':
					intialConfig.SterilizerMachineLength = value === 'M2' ? 2 : 3;
					break;
				case 'C2':
				case 'C3':
					intialConfig.SterilizerCycleNumberLength = value === 'C2' ? 2 : 3;
					break;
				default:
					if (!loadNumExist) {
						if (value !== '_' && value !== '-') {
							intialConfig.DateFormat += value;
						}
						else {
							intialConfig.SplitChar = value;
						}
						LoadNumber += dayjs().format(value);
					}
					else {
						intialConfig.DateFormat += value;
					}
			}
		});
		intialConfig.LoadNumber = LoadNumber;
		intialConfig.DefaultLoadNumber = loadNumExist ? "" : LoadNumber;
		intialConfig.loadNumExist = loadNumExist;
		intialConfig.validUserInputLength = intialConfig.SterilizerMachineLength + intialConfig.SterilizerCycleNumberLength + LoadNumber.length;
		// if (!data.AcknowledgeTime) {
		// 	let value = data.LoadNumber;
		// 	let modifiedValue = value.replace(this.intialConfig.LoadNumber.split('-')[0] + "-", '');
		// 	let machineId = modifiedValue.substring(0, this.intialConfig.SterilizerMachineLength);
		// 	this.sterilizerCycleNumber = modifiedValue.substring(this.intialConfig.SterilizerMachineLength, this.intialConfig.SterilizerMachineLength + this.intialConfig.SterilizerCycleNumberLength);
		// 	this.getSterilizer(machineId, value, true);
		// }
		// newState.canSelectSterilizer = (data.TestOrControl === consts.TestOrControl.Control) ? false : true;
		return intialConfig
	}
}

const CyclesBtn = ({ formik, setFieldValue, activeRecord, disabled, readOnly }) => {
	const leftPad = (s = "", c = "", n = "") => { s = s.toString(); c = c.toString(); return s.length > n ? s : c.repeat(n - s.length) + s; };
	const [state, setState] = useReducer(
		(prev, next) => (typeof next === 'function' ? { ...prev, ...next(prev) } : { ...prev, ...next }),
		{
			loading: false,
			selectedId: null,
			open: false,
			selectedRecord: null,
			isFormValidate: false,
			preIncubation: true,
			isSterilized: false,
			isIncubated: false,
			canSelectSterilizer: false,
			isStream: false,
			saveDisable: true,
			showAcknowledgeBtn: false,
			isControl: false,
			isAcknowledge: false,
			enableCycleCountandCycleName: false,
			isProcessedSterilizer: false,
			processLoadNumber: '',
			json: null,
			isFromCycleScreen: true,
			isfromProcessSterilizer: false
		}
	);
	disabled = !!activeRecord?.record?.AcknowledgeTime || !!formik.values?.Control;
	readOnly = !!activeRecord?.record?.AcknowledgeTime || !!formik.values?.Control;
	const location = useLocation();
	const onProcess = useCallback(({ params = {} } = {}) => {
		let updatedJson = { ...state.selectedRecord };
		const { NONSTERISHP, NONSTERISSTEAM } = consts.EquipmentFamilyType;
		const { SterilizerCycleId, SterilizerId, CycleCount, CycleTypeName, LoadNumber, CycleStart, MachineNumber, CycleNumberForDay, EquipmentFamilyId } = state.selectedRecord;
		const enableCycleCountandCycleName = [NONSTERISHP, NONSTERISSTEAM].includes(EquipmentFamilyId);
		let intialConfig = { LoadNumber: '', SterilizerMachineLength: 0, SterilizerCycleNumberLength: 0, DateFormat: '', SplitChar: '' };
		const utilLoadNumberFormat = util.localData.LoadNumberFormat;
		const utitagsLoadNumberFormat = util.localData.loginData.tags.LoadNumberFormat;
		const loaddata = getLoadDateFormat({ LoadNumber, intialConfig, utilLoadNumberFormat, utitagsLoadNumberFormat });
		const config = { ...intialConfig, ...loaddata };
		const loadNumber = dayjs(dateUtil.parse(state.selectedRecord.CycleStart)).format(config.DateFormat) + config.SplitChar + leftPad(state.selectedRecord.MachineNumber, '0', config.SterilizerMachineLength) + leftPad(state.selectedRecord.CycleNumberForDay, '0', config.SterilizerCycleNumberLength)
		Object.assign(updatedJson, {
			SterilizerCycleId: SterilizerCycleId,
			SterilizerId: SterilizerId,
			CycleCount: CycleCount,
			CycleTypeName: CycleTypeName,
			LoadNumber: dayjs(dateUtil.parse(state.selectedRecord.CycleStart)).format(config.DateFormat) + config.SplitChar + leftPad(state.selectedRecord.MachineNumber, '0', config.SterilizerMachineLength) + leftPad(state.selectedRecord.CycleNumberForDay, '0', config.SterilizerCycleNumberLength),
		});
		config.LoadNumber = dayjs(dateUtil.parse(state.selectedRecord.CycleStart)).format(config.DateFormat) + '-';
		setState({ selectedRecord: updatedJson, isSterilized: true, preIncubation: false, saveDisable: false, isIncubated: params.hasOwnProperty("incubatorCycleId") ? !!params.incubatorCycleId : updatedJson.IncubatorCycleId, showAcknowledgeBtn: params.hasOwnProperty("incubatorCycleId") ? !!params.incubatorCycleId : updatedJson.IncubatorCycleId, isProcessedSterilizer: true, processLoadNumber: updatedJson.LoadNumber, enableCycleCountandCycleName });
		setState({ loading: false, open: false });
		formik.setFieldValue('SterilizerCycleId', SterilizerCycleId);
		formik.setFieldValue('SterilizerId', SterilizerId);
		formik.setFieldValue('SterilizerCycleCount', CycleCount);
		formik.setFieldValue('SterilizerCycleTypeName', CycleTypeName);
		formik.setFieldValue('LoadNumber', loadNumber);
		formik.setFieldValue('isNon', !enableCycleCountandCycleName)
		formik.setFieldValue('isfromProcessSterilizer', enableCycleCountandCycleName);
		formik.setFieldValue('isReadByDisable', enableCycleCountandCycleName);
		formik.setFieldValue('isIncubated', true);

	}, [formik, state.selectedRecord]);


	return (
		<Box>
			<ActionIconButton variant="contained" disabled={disabled || readOnly} color="success" onClick={() => setState({ open: true })}>
				<LinkIcon />
			</ActionIconButton>
			<Dialog sx={{ marginTop: '50px' }} open={state.open} onClose={() => setState({ open: false })} fullWidth={true} maxWidth={isDesktop ? 'lg' : 'sm'}>
				<DialogTitle sx={{ color: 'primary.main' }}>{strings.Sterilizercycle}</DialogTitle>
				<DialogContent>
					{state.open && <SterilizerCycleTable
						disablePreferences
						onSelection={(id, { row: record }) => {
							setState({ selectedId: id, selectedRecord: record });
						}}
						location={location}
						parentFilters = {{
							filter: [
							{
								"operator": "$eq",
								"property": "IsSterilized",
								"value": false
							}
						]}}
					/>
					}
				</DialogContent>
				<DialogActions>
					<Button variant="contained" color="primary" onClick={onProcess} disabled={!state.selectedId}>{strings.Process}</Button>
					<Button variant="contained" color="warning" onClick={() => { setState({ open: false }) }}>{strings.Cancel} </Button>
				</DialogActions>
			</Dialog>

			<LoadingDialog open={state.loading} />
		</Box>
	)
}
const handleLoadNumberChange = ({ formik, activeRecord, value, field }) => {

	const { record } = activeRecord;
	const { NONSTERISHP, NONSTERISSTEAM } = consts.EquipmentFamilyType;
	const isNonSteris = [NONSTERISHP, NONSTERISSTEAM].includes(record.EquipmentFamilyId);
	let loginData = util.localData.loginData || {};
	const LoadNumber = value;
	const utilLoadNumberFormat = util.localData.LoadNumberFormat;
	const utitagsLoadNumberFormat = util.localData.loginData.tags.LoadNumberFormat;
	const loaddata = getLoadDateFormat({ LoadNumber, intialConfig, utilLoadNumberFormat, utitagsLoadNumberFormat });
	const config = { ...intialConfig, ...loaddata };
	let modifiedValue;
	let machineId;
	if (loginData.tags) {
		let loadNumberFormat = util.localData.LoadNumberFormat ? util.localData.LoadNumberFormat.replace(/\//g, "") : loginData.tags.LoadNumberFormat.replace(/\//g, "");
		if (config.validUserInputLength >= value.length) {
			let dateFormat = loadNumberFormat.split('-');
			if (dateFormat.length === 0) {
				dateFormat = loadNumberFormat.split('_');
			}
			config.LoadNumber = dateFormat.length === 0 ? '' : dateFormat[0] + '-';
			if (config.LoadNumber && config.LoadNumber.length < value.length) {
				config.LoadNumber = value.substring(0, config.LoadNumber.length);
				modifiedValue = value.replace(config.LoadNumber, '');
				if (config.SterilizerMachineLength + config.SterilizerCycleNumberLength < modifiedValue.length) {
					// updateValue = false;
				}
			}
			formik.setFieldValue(field, value);
			formik.setStatus({ ...formik.status, showAcknowledgeBtn: isNonSteris && !formik.values.isAcknowledge ? true : config.validUserInputLength === value.length && !!formik.values.IsIncubated });
			modifiedValue = value.replace(config.LoadNumber, '');
			machineId = modifiedValue.substring(0, config.SterilizerMachineLength);
			activeRecord.record.SterilizerCycleNumber = modifiedValue.substring(config.SterilizerMachineLength, config.SterilizerMachineLength + config.SterilizerCycleNumberLength);
			getSterilizer(machineId, value, formik, activeRecord, 'Sterilizer', config);
		}
		else {
			formik.setStatus({ ...formik.status, showAcknowledgeBtn: isNonSteris && !formik.status.isAcknowledge ? true : false });
		}
	}
	formik.setFieldValue('LoadNumber', value);

};


const handleLotNumberChange = ({ formik, activeRecord, value, field }) => {
	const { combos } = activeRecord;
	let comboName = field.replaceAll('Id', '');

	if (combos && Object.keys(combos).length !== 0 && comboName === consts.LotNumberType[comboName]) {
		let selectedCombo = combos[comboName].find(item => item.LookupId === value);

		if (selectedCombo) {
			const { LotControlDate = '', ExpiryDate = '', LotControlResult = 0 } = selectedCombo;
			formik.setFieldValue("IndicatorName", selectedCombo.IndicatorName);
			formik.setFieldValue('LotControlResult', LotControlResult);
			formik.setFieldValue('LotControlDate', dayjs(LotControlDate.replace(regex.DateExtract, "")).toDate()) // Remove $D{ and } from the LotControlDate string to extract the date value
			// Remove the prefix "$D{" and suffix "}" from ExpiryDate
			const dateStr = ExpiryDate.replace(regex.DateExtract, "");

			// Then convert the cleaned string to a date
			const expiryDate = consts.isNodeServer ? dayjs(dateStr).toDate() : util.customDateTimeDisplay(dateStr, consts.MomentFormat.Date);

			formik.setFieldValue("IndicatorSerialNumber", '');
			if (field !== 'CILotNumberId' && !formik.values.Control) { 
				formik.setFieldValue("Implant", selectedCombo.IsSteam);
			}
			if (dayjs().isBefore(dayjs(expiryDate))) {
				field !== 'CILotNumberId' && formik.setFieldValue('ExpiryDate', dayjs(expiryDate).format("YYYY-MM-DD"));
			}
			else {
				setTimeout(() => Swal.fire({
					titleText: "Are you sure?",
					text: strings.BIExpired,
					icon: "warning",
					showCancelButton: true,
					confirmButtonClass: "btn-danger",
					confirmButtonText: strings.Yes,
					cancelButtonText: strings.No,
					closeOnConfirm: true,
					closeOnCancel: true,
					allowOutsideClick: false
				}).then((result) => {
					if (result.isConfirmed) {
						field !== 'CILotNumberId' ? formik.setFieldValue('BILotNumberId', selectedCombo.id) : formik.setFieldValue('CILotNumberId', selectedCombo.id);
						field !== 'CILotNumberId' && formik.setFieldValue('ExpiryDate', dayjs(expiryDate).format("YYYY-MM-DD"));
					}
					else if (result.isDismissed) {
						field !== 'CILotNumberId' ? formik.setFieldValue('BILotNumberId', '') : formik.setFieldValue('CILotNumberId', '');
						field !== 'CILotNumberId' && formik.setFieldValue('ExpiryDate', null);
					}
				}), 150)

			}
		}
	} else if (Object.keys(combos).length === 0 && comboName === consts.LotNumberType.BILotNumber) {
		formik.setFieldValue('ExpiryDate', null);
		formik.setFieldValue("IndicatorSerialNumber", '');
		formik.setFieldValue("Implant", false);
	}
}

const onReusableTestPackChange = ({ formik, activeRecord, value, field }) => {
	const { combos } = activeRecord;

	let comboName = field.replaceAll('Id', '');

	if (combos && Object.keys(combos).length !== 0 && comboName === 'ReusableTestPack') {
		let selectedCombo = combos.ReusableTestPack.find(item => item.LookupId === value);

		if (selectedCombo) {
			if (selectedCombo.CanUse) {
				// Update old value for combo to reusable
				let index = combos.ReusableTestPack.findIndex(item => item.LookupId === value);
				if (index !== -1) {
					combos.ReusableTestPack[index].CanUse = true;
				}
				formik.setFieldValue(field, value);
			}
			else {
				Swal.fire({ titleText: strings.Info, text: strings.ReusableTestPackIsFullyUse, icon: 'info', confirmButtonText: strings.Ok, allowOutsideClick: false });
				formik.setFieldValue(field, '');
			}
		}
	}
};

const handleSterilizerChange = ({ formik, activeRecord, value, field }) => {
	const { combos } = activeRecord;
	let comboName = field.replaceAll('Id', '');

	if (combos && Object.keys(combos).length !== 0 && comboName === 'Sterilizer') {
		let selectedSterilizer = combos.Sterilizer.find(item => item.LookupId === value);

		if (selectedSterilizer) {
			const sterilizerCycleCount = formik.values.SterilizerCycleCount;
			const { NONSTERISHP, NONSTERISSTEAM } = consts.EquipmentFamilyType;
			const enableCycleCountandCycleName = [NONSTERISHP, NONSTERISSTEAM].includes(selectedSterilizer.EquipmentFamilyId);
			formik.setFieldValue(field, value);
			formik.setFieldValue('SterilizerCycleCount', sterilizerCycleCount);
			formik.setFieldValue('SterilizerCycleTypeName', '');
			formik.setFieldValue('isNon', !enableCycleCountandCycleName)
			formik.setFieldValue('isfromProcessSterilizer', !enableCycleCountandCycleName)
			formik.setFieldValue('isReadByDisable', enableCycleCountandCycleName);
			formik.setStatus({ ...formik.status, enableCycleCountandCycleName, saveDisable: !enableCycleCountandCycleName, nonSterisCycle: enableCycleCountandCycleName, EquipmentTypeId: selectedSterilizer.EquipmentTypeId });
		}
	}
};

const getSterilizer = (machineId, loadNumber, formik, activeRecord = {}, field, config) => {
	const { combos = {}, record = {} } = activeRecord;
	let comboName = field.replaceAll('Id', '');
	let sterilizerCombo = combos[comboName] || comboName === 'Sterilizer' ? combos.Sterilizer : null;
	let comboData;

	if (sterilizerCombo) {
		comboData = sterilizerCombo.find(item => item['CustomStringValue'] === machineId);
	}
	const sterilizerCycleNumber = activeRecord?.record?.SterilizerCycleNumber;
	formik.setFieldValue('SterilizerId', comboData?.LookupId);
	const { NONSTERISHP, NONSTERISSTEAM } = consts.EquipmentFamilyType;
	let isNonSteris = false;
	if (comboData) {
		let conectivityType = comboData.ConnectivityType;
		combos['SterilizerId'] = comboData.LookupId;
		isNonSteris = [NONSTERISHP, NONSTERISSTEAM].includes(comboData.EquipmentFamilyId);
		formik.setStatus({
			...formik.status,
			enableCycleCountandCycleName: isNonSteris,
			canSelectSterilizer: true,
			saveDisable: false,
			isConectivityTypeIsNone: conectivityType === consts.ConnectivityType.None,
			isSterilized: conectivityType === consts.ConnectivityType.None,
		});

		if (conectivityType && conectivityType === consts.ConnectivityType.None) {
			formik.setStatus({
				...formik.status,
				isConectivityTypeIsNone: true,
				isSterilized: true,
			})
		}
		if (sterilizerCycleNumber) {
			let loginData = util.localData.loginData || {};
			let loadNumberFormat = util.localData.LoadNumberFormat ? util.localData.LoadNumberFormat.split('/') : loginData.tags.LoadNumberFormat.split('/');
			let i = 0;
			let month, year, day;
			loadNumberFormat.forEach(value => {
				switch (value) {
					case 'M2':
					case 'M3':
						config.SterilizerMachineLength = value === 'M2' ? 2 : 3;
						i = value === 'M2' ? (i + 2) : (i + 3);
						break;
					case 'C2':
					case 'C3':
						config.SterilizerCycleNumberLength = value === 'C2' ? 2 : 3;
						i = value === 'C2' ? (i + 2) : (i + 3);
						break;
					default:
						if (value === 'MM') {
							month = loadNumber.substring(i, i + 2);
							i = i + 2;
						}
						if (value === 'YY') {
							year = loadNumber.substring(i, i + 2);
							i = i + 2;
						}
						if (value === 'MMM') {
							month = loadNumber.substring(i, i + 3);
							i = i + 3;
						}
						if (value === 'DD') {
							day = loadNumber.substring(i, i + 2);
							i = i + 2;
						}
				}
			});
			const date = dayjs([20 + year, month, day]).format(consts.MomentFormat.DateTimeFormat);
			const formData = new FormData();
			formData.append('action', 'otherAction');
			formData.append('otherAction', 'LoadCycle');
			formData.append('id', comboData.LookupId);
			formData.append('serialNumber', comboData.SerialNumber);
			formData.append('date', date);
			formData.append('cycleNumberForDay', activeRecord?.record?.SterilizerCycleNumber);

			fetch(connectionService.IncubatorCycle, { method: 'POST', body: formData })
				.then(res => res.json())
				.then(json => {
					if (json.data !== null) {
						const record = json.data;
						let isValid = (record?.data && record?.data?.Success) || record.Success;
						if (isValid && record.IncubatorCycleDetailId === 0) {
							formik.setFieldValue('SterilizerCycleCount', isValid ? record.SterilizerCycleCount : 0);
							formik.setFieldValue('SterilizerCycleTypeName', isValid ? record.SterilizerCycleTypeName : '');
							activeRecord.record.SterilizerCycleId = record.SterilizerCycleId;
							formik.setFieldValue('SterilizerCycleId', isValid ? record.SterilizerCycleId : 0);
							formik.setStatus({ isSterilized: isValid, preIncubation: false, showAcknowledgeBtn: isNonSteris && !formik.status.isAcknowledge ? true : (isValid && record.BIInTime && record.BIReadTime) });
						}
						else {
							formik.setFieldValue('SterilizerCycleCount', 0);
							formik.setFieldValue('SterilizerCycleTypeName', '');
							formik.setFieldValue('SterilizerCycleId', 0);
							formik.setStatus({
								...formik.status,
								isSterilized: false,
								preIncubation: true,
								showAcknowledgeBtn: isNonSteris && !formik.status.isAcknowledge ? true : false
							});

							if (conectivityType !== consts.ConnectivityType.None) {
								if (isValid && record.IncubatorCycleDetailId > 0) {
									Swal.fire({
										titleText: strings.Alert,
										text: strings.BILinked,
										closeOnConfirm: true,
										icon: "error",
										confirmButtonText: strings.Ok,
										allowOutsideClick: false
									}).then(() => {
										formik.setFieldValue('LoadNumber', config.DefaultLoadNumber);
										formik.setStatus({
											...formik.status,
											saveDisable: true
										})
									});
								}
								else if (!isValid && !formik.status.msgBINotLinkedShowed) {
									Swal.fire({
										titleText: strings.Alert,
										text: strings.BINotLinked,
										closeOnConfirm: true,
										type: "error",
										confirmButtonText: strings.Ok,
										allowOutsideClick: false
									}).then(() => {
										formik.status({
											...formik.status,
											msgBINotLinkedShowed: true
										})
									});
								}
							}
						}

					}
				}).catch(err => {
					console.error(err);

				});
		}
		return;
	} else {
		combos['SterilizerId'] = 0;
		formik.setStatus({
			...formik.status,
			canSelectSterilizer: false,
			showAcknowledgeBtn: isNonSteris && !formik.status.isAcknowledge ? true : false,
			saveDisable: true
		})
		Swal.fire({
			titleText: strings.Info,
			text: strings.MachineValidation,
			closeOnConfirm: true,
			icon: "info",
			confirmButtonText: strings.Ok,
			allowOutsideClick: false
		}).then(() => {
			formik.setFieldValue(field, config.DefaultLoadNumber);
			formik.setStatus({
				...formik.status,
				saveDisable: true
			})
		});
	}

	return { formik, combos };
}

const SterilizerCycleinfoBtn = ({ formik, activeRecord, disabled, readOnly }) => {
	const { record } = activeRecord;
	const showButton = record.SterilizerCycleId !== undefined && record.SterilizerCycleId !== '';
	return (
		showButton && (
			<ActionIconButton
				variant="contained"
				component={Link}
				to={`/sterilizerCycleinfo?id=${activeRecord.record.SterilizerCycleId}`}
				color="success"
			>
				<OpenInNewIcon fontSize='inherit' />
			</ActionIconButton>
		)
	)
}


const CiResultButton = ({ inputProps }) => {
	const { formik, activeRecord } = inputProps;
	return (
		<Stack direction="row" spacing={2} sx={{
			'& .MuiIconButton-root': {
				'&.IsSelected': {
					backgroundColor: (theme) => theme.palette.divider,
				}
			}
		}}>
			{(formik.values.CIResult === 1 || formik.values.CIResult === 0) && <IconButton color="success" className={parseInt(activeRecord?.CIResult) === 1 ? 'IsSelected' : ''} onClick={() => {
				if (!formik?.values?.Control && !formik?.values?.IsAcknowledge) {
					formik.setFieldValue('CIResult', 1)
					activeRecord.CIResult = 1
				}
			}}>
				<CheckCircle fontSize='large' />
			</IconButton>}
			{(formik.values.CIResult === 2 || formik.values.CIResult === 0) && <IconButton color="error" className={parseInt(activeRecord?.CIResult) === 2 ? 'IsSelected' : ''} onClick={() => {
				if (!formik?.values?.Control && !formik?.values?.IsAcknowledge) {
					formik.setFieldValue('CIResult', 2)
					activeRecord.CIResult = 2
				}
			}}>
				<Cancel fontSize='large' />
			</IconButton>}
		</Stack>
	)
}
const BiResultButtons = ({ inputProps }) => {
	const { formik, activeRecord } = inputProps;
	const { isWellDisable } = activeRecord?.record || {};
	return (
		<Stack direction="row" spacing={2} sx={{
			'& .MuiIconButton-root': {
				'&.IsSelected': {
					backgroundColor: (theme) => theme.palette.divider,
				}
			}
		}}>
			{(formik.values.BIResult === 1 || formik.values.BIResult === 0) && <IconButton className={parseInt(formik?.values?.BIResult) === 1 ? 'IsSelected' : ''} color={formik.values?.Control ? 'success' : 'error'} onClick={() => { if (isWellDisable) { formik.setFieldValue('BIResult', 1) } }}>
				<Add fontSize='large' />
			</IconButton>}
			{(formik.values.BIResult === 2 || formik.values.BIResult === 0) && <IconButton className={parseInt(formik?.values?.BIResult) === 2 ? 'IsSelected' : ''} color={formik.values?.Control ? 'error' : 'success'} onClick={() => { if (isWellDisable) { formik.setFieldValue('BIResult', 2) } }}>
				<Remove fontSize='large' />
			</IconButton>}
			{(formik.values.BIResult === 3 || formik.values.BIResult === 0) && <IconButton className={parseInt(formik?.values?.BIResult) === 3 ? 'IsSelected' : ''} color="error" onClick={() => {
				if (isWellDisable && formik.values.BIResult !== null) { formik.setFieldValue('BIResult', 3) }
			}}>
				<PriorityHighIcon fontSize='large' />
			</IconButton>}
		</Stack>
	)
}
const validateAcknowledge = ({ activeRecord = {}, formik = {} }) => {
	const { record } = activeRecord;
	const { AcknowledgeTime = '' } = record;
	return !!AcknowledgeTime;
}
const TestButton = ({ Input, inputProps: { formik, activeRecord } }) => {
	const { record } = activeRecord;
	const { SterilizerId = '', LoadNumber = '', isAcknowledge } = record;
	const location = useLocation();
	const isTest = !!SterilizerId || isAcknowledge;
	const HandleChange = () => {
		if (!isTest) {
			formik.setFieldValue('Test', true);
			formik.setFieldValue('Control', false);
			formik.setFieldValue('LoadNumber', LoadNumber);
			formik.setFieldValue('TestOrControl', 0);
			location.state = { ...location?.state, isControl: false }
		}
	}
	return (
		<Button type='button' variant={formik.values?.Test ? 'contained' : "outlined"} color={formik.values?.Test ? 'success' : "primary"} onClick={HandleChange} className={'input-button'}>
			{strings.Test}
		</Button>
	)
}

const ControlButton = ({ Input, inputProps: { formik, activeRecord } }) => {
	const { record } = activeRecord;
	const { SterilizerId = '', isAcknowledge = false } = record;
	const isTest = !!SterilizerId || isAcknowledge || !!formik.values.SterilizerId;
	const location = useLocation();
	const handleChange = () => {
		if (!isTest) {
			formik.setFieldValue('Control', true);
			formik.setFieldValue('Test', false);
			formik.setFieldValue('Implant', false);
			formik.setFieldValue('LoadNumber', '');
			formik.setFieldValue('TestOrControl', 1);
			formik.setFieldValue('ReusableTestPackId', '');
			location.state = { ...location?.state, isControl: true }
		}
	}
	return (
		<Button
			type="button"
			variant={formik.values?.Control ? 'contained' : 'outlined'}
			color={formik.values?.Control ? 'success' : 'primary'}
			onClick={handleChange}
			className={'input-button'}
		>
			{strings.Control}
		</Button>
	);
}

const isControlOrAcknowledged = ({ formik }) => {
	return Boolean(formik.values?.IsAcknowledge) || formik.values?.Control;
}

const lotNumberRenderProps = (params) => {
	const value = params.inputProps.value;
	const date = dayjs(value).toDate();
	const isExpired = dayjs().isAfter(dayjs(date));
	return {
		sx: {
			color: isExpired ? 'red' : 'inherit',
		}
	}
}

const LotNumberOptions = (params, option) => {
	const dateStr = option.ExpiryDate.replace("$D{", "").replace("}", "");
	const expiryDate = consts.isNodeServer ? dayjs(dateStr).toDate() : util.customDateTimeDisplay(dateStr, consts.MomentFormat.Date);
	const isExpired = dayjs().isAfter(dayjs(expiryDate));
	return (
		<li {...params} key={option.id} className={`${params?.className || ''} ${isExpired ? 'expired-lot' : ''}`}>
			{option.label}
		</li>
	);
}

const model = new Model({
	name: 'incubatorCycleDetailForm',
	idProperty: '_id',
	disableAdd: true,
	disableDelete: true,
	initialValues: {
		LoadNumber: '', SterilizerMachineLength: 0, SterilizerCycleNumberLength: 0, DateFormat: '', SplitChar: '', DefaultWellNumber: 20
	},
	disableExport: true,
	formTitleField: 'IndicatorName',
	defaultSort: [{ field: ' IndicatorName', sort: 'desc' }],
	customField: ["CILotNumberId", 'BILotNumberId', 'CIResult', 'BIResult', 'TestOrControl', 'ExpiryDate', 'BIReadTime', 'BIInTime', 'ReadTime', 'AcknowledgeTime', 'SterilizerId', 'IncubatorId', 'ReusableTestPackId', 'IndicatorSerialNumber', 'IndicatorName'],

	customizeSaveData: (toSave, formik) => {
		const { activeRecord } = formik;
		const { record } = activeRecord;
		const { isNew, isError } = record;
		if (formik.values.sterilizerCycleNumber) {
			toSave.SterilizerCycleNumber = formik.values.sterilizerCycleNumber;
		}
		let loadDate = formik?.status?.loadDate || false;
		//Discard support data:
		delete toSave.isError;
		if (loadDate) {
			if (loadDate.SterilizerCycleId) {
				toSave.SterilizerCycleId = loadDate.SterilizerCycleId;
			}
			if (loadDate.IncubatorCycleId) {
				toSave.IncubatorCycleId = loadDate.IncubatorCycleId;
			}
		}
		if (isError) {
			toSave.TestOrControl = 0;
			toSave.ReadTime = undefined;
			toSave.IndicatorName = record.IndicatorName;
			toSave.CILotNumberId = undefined;
			toSave.IncubatorCycleId = record.IncubatorCycleId;
			toSave.id = 0;
			toSave = util.deleteKeys(toSave, errorFormKeysToDelete);

		} else {
			toSave.TestOrControl = toSave.Test ? consts.incubatorTest : consts.incubatorControl;
			delete toSave.Test;
			delete toSave.Control;
			toSave.CycleId = 0;
			toSave.CIReadByID = toSave.CIReadByID || 0;
			toSave.CILotNumberId = toSave.CILotNumberId || undefined;
			toSave.IndicatorName = record.IndicatorName;
			toSave.ReadTime = undefined;
			toSave.id = isNew ? 0 : record.IncubatorCycleDetailId || record.IncubatorCycleDetail;
			toSave.IncubatorCycleId = record.IncubatorCycleId;
			toSave.BIResult = record.BIResult ? record.BIResult : 0;
			toSave.SterilizerCycleId = formik.values?.SterilizerCycleId;
			toSave.SterilizerId = toSave.SterilizerId || 0;
		}
		if (isNew) {
			toSave.BIResult = formik.values.BIResult || 0;
			toSave.CIResult = formik.values.CIResult || 0;
		}
		return toSave;
	},
	comboTypes: [
		{ "type": "Indicator", "loaded": true },
		{ "type": "BILotNumber", "loaded": true },
		{ "type": "User", "loaded": true },
		{ "type": "CILotNumber", "loaded": true },
		{ "type": "ReusableTestPack", "loaded": true },
		{ "type": "Sterilizer", "loaded": true },
		{ "type": "Incubator", "loaded": true },
		{ "type": "IncubatorUser", "loaded": true }
	],
	formGroups: [
		{
			header: 'BiologicalIndicator',
			fields: ['Test', 'Control', 'Implant', 'BILotNumberId', 'ExpiryDate', 'LoadNumber', 'IndicatorSerialNumber', 'IncubatorId', 'ReusableTestPackId', 'Well', 'MinTemp', 'BIResult', 'MaxTemp', 'BIInTime', 'BIModel', 'BIReadTime', 'RunById', 'AcknowledgeTime', 'BIReadById', 'LotControlResult', 'LotControlDate'],
			columnSize: 6,
			headerProps: ({ activeRecord }) => ({
				sx: {
					padding: (theme) => theme.spacing(1.5),
					backgroundColor: 'primary.main',
					textAlign: 'center',
					width: '100%',
					color: 'background.paper',
					borderRadius: (theme) => theme.spacing(0.5)
				},
			}),
			fieldProps: {
				inlineLabelSize: 3,
			}
		},
		{
			header: 'Sterilizer And Cycle Information',
			fields: ['SterilizerId', 'SterilizerCycleTypeName', 'SterilizerCycleCount'],
			columnSize: 6,
			headerProps: ({ activeRecord, formik }) => ({
				sx: {
					padding: (theme) => theme.spacing(1.5),
					backgroundColor: 'primary.main',
					textAlign: 'center',
					width: '100%',
					color: 'background.paper',
					borderRadius: (theme) => theme.spacing(0.5),
				},
				hidden: activeRecord?.record?.isError
			})
			,
			fieldProps: {
				inlineLabelSize: 3,
			},
		},
		{
			header: 'Chemical Indicator',
			fields: ['CILotNumberId', 'CIResult', 'CIReadById'],
			columnSize: 6,
			containerProps: ({ activeRecord, formik }) => ({ sx: { display: !formik.values.Test ? 'none' : 'flex' } }),
			headerProps: ({ activeRecord, formik }) => ({
				sx: {
					padding: (theme) => theme.spacing(1.5),
					backgroundColor: 'primary.main',
					textAlign: 'center',
					width: '100%',
					color: 'background.paper',
					borderRadius: (theme) => theme.spacing(0.5),
					// display: 'initial'

				},
				hidden: !formik.values.Test || activeRecord?.record?.isError
			}),
			fieldProps: {
				inlineLabelSize: 3,
			},
		},
		{
			fields: ['IsAuthorize'],
			columnSize: 12
		}
	],
	onFormLoad: (param) => {
		let { formik, activeRecord = { record: {} } } = param
		let { record, id, combos } = activeRecord;
		let comboName = 'BILotNumber';
		if (combos && Object.keys(combos).length !== 0 && comboName === consts.LotNumberType[comboName]) {
			let selectedCombo = combos[comboName].find(item => item.LookupId === record.BILotNumberId);
			if (selectedCombo) {
				const { LotControlDate = '' } = selectedCombo;
				const dateStr = LotControlDate.replace(regex.DateExtract, ""); // Remove $D{ and } from the LotControlDate string to extract the date value
				formik.setFieldValue('LotControlResult', selectedCombo.LotControlResult);
				formik.setFieldValue('LotControlDate', dayjs(dateStr).toDate())
			}
		}
		const AcknowledgeTime = record.AcknowledgeTime;
		formik.setFieldValue('isError', record?.isError);
		formik.setFieldValue('BIReadTime', util.customDateTimeDisplay(record.BIReadTime, consts.MomentFormat.DateTimeFormatAMPM));
		formik.setFieldValue('BIInTime', util.customDateTimeDisplay(record.BIInTime, consts.MomentFormat.DateTimeFormatAMPM));
		if (AcknowledgeTime) {
			formik.setFieldValue('AcknowledgeTime', dayjs(AcknowledgeTime?.replace(regex.DateExtract, "")).toDate());
		}
	},
	columns: [
		// Biological Indicator Columns
		{
			field: 'Test',
			header: 'Test',
			type: 'bool',
			columnSize: 1,
			customizeInput: TestButton,
			hideLabel: true,
			inputWhen: ({ activeRecord }) => (!activeRecord.record.isError),
		},
		{
			field: 'Control',
			header: 'Control',
			type: 'bool',
			columnSize: 5,
			customizeInput: ControlButton,
			inputWhen: ({ activeRecord }) => (!activeRecord.record.isError),
			hideLabel: true,
		},
		{
			field: 'Implant',
			disabled: isControlOrAcknowledged,
			header: 'Implant',
			type: 'bool',
			width: 75,
			hide: true,
			hidden: true,
			excludeOnGrid: true,
			inputWhen: ({ activeRecord }) => (!activeRecord.record.isError),
			readOnly: isControlOrAcknowledged
		},
		{
			field: 'BILotNumberId',
			header: 'LotNumber',
			width: 200,
			lookup: 'BILotNumber',
			required: [['isError', false]],
			addable: ({ formik, activeRecord }) => {
				return `/lotdetaillist?id=new&returnTo=${encodeURIComponent(`/incubatorcycledetailform?id=${(activeRecord?.record?.id || 0)}&incubatorCycleId=${formik?.values?.IncubatorCycleId || 0}&isError=${activeRecord.record?.BIResult === consts.BIResult.Error}&isFromCycle=${activeRecord.record?.isFormCycleScreen}&returnTo=/equipmentinfo?id=${activeRecord.record?.IncubatorId}&name=${activeRecord.record.IncubatorName || ''}&isSterilizer=${false}&isIncubator=${true}&isFromEquipmentDetail=${true}&equipmentType=${activeRecord.record.EquipmentType}&equipmentTypeId=${activeRecord.record.EquipmentTypeId}&EquipmentId=${activeRecord.record?.IncubatorId}`)}`
			},
			editable: ({ formik, activeRecord }) => {
				return `/lotdetaillist?id=${formik.values.BILotNumberId}&returnTo=${encodeURIComponent(`/incubatorcycledetailform?id=${(activeRecord?.record?.id || 0)}&incubatorCycleId=${formik?.values?.IncubatorCycleId || 0}&isError=${activeRecord.record?.BIResult === consts.BIResult.Error}&isFromCycle=${activeRecord.record?.isFormCycleScreen || false}&returnTo=/equipmentinfo?id=${activeRecord.record?.IncubatorId}&name=${activeRecord.record.IncubatorName || ''}&isSterilizer=${false}&isIncubator=${true}&isFromEquipmentDetail=${true}&equipmentType=${activeRecord.record.EquipmentType}&equipmentTypeId=${activeRecord.record.EquipmentTypeId}&EquipmentId=${activeRecord.record?.IncubatorId}`)}`
			},
			onChange: handleLotNumberChange,
			eager: true,
			inputProps: {
				autoSelect: true,
				blurOnSelect: true,
				disableClearable: true,
				renderOption: LotNumberOptions,
				renderInputProp: lotNumberRenderProps
			},
			inputWhen: ({ activeRecord }) => (!activeRecord.record.isError),
			readOnly: validateAcknowledge,
			disabled: validateAcknowledge
		},
		{ field: 'ExpiryDate', header: `ExpiryDate`, type: 'date', width: 200, isLocal: true, readOnly: true, disabled: true, inputWhen: ({ activeRecord }) => (!activeRecord.record.isError) },
		{
			field: 'LoadNumber', header: 'LoadNumber', width: 100, required: [['Control', false]],
			readOnly: [['Control', true]],
			onChange: debounce(100, handleLoadNumberChange), inputWhen: ({ activeRecord }) => (!activeRecord.record.isError),
			eager: true,
			disabled: validateAcknowledge
		},
		{ field: 'IndicatorSerialNumber', header: 'IndicatorSN', width: 200, inputWhen: ({ activeRecord }) => (!activeRecord.record.isError), disabled: validateAcknowledge },
		{ field: 'IncubatorId', header: 'BIName', width: 200, lookup: 'Incubator', readOnly: [['isIncubatorIdDisable', true]], required: true, type: 'string', ignoreLookupOnGridFilter: true },
		{
			field: 'ReusableTestPackId',
			header: 'ReusableTestPack',
			width: 200,
			lookup: 'ReusableTestPack',
			readOnly: isControlOrAcknowledged,
			onChange: onReusableTestPackChange,
			inputWhen: ({ activeRecord }) => (!activeRecord.record.isError)
		},
		{
			field: 'Well', header: 'NumberOfWell', type: 'number', width: 200, minValue: 0,
			maxValue: 200,
			readOnly: [['isWellDisable', true]],
			disabled: validateAcknowledge
		},
		{
			field: 'MinTemp', header: 'MinTemperature', type: 'number', inputProps: { inputProps: { step: 0.1 } }, width: 200, readOnly: [['Control', true]], decimal: true, disabled: true, inputWhen: ({ activeRecord }) => (!activeRecord.record.isError)
		},
		{ field: 'BIResult', header: 'BIResult', type: 'number', width: 200, customizeInput: BiResultButtons },
		{ field: 'BIModel', header: 'BIModel', readOnly: true, inputProps: { inputProps: { step: 0.1 } }, width: 200, inputWhen: ({ activeRecord }) => (!activeRecord.record.isError) },
		{ field: 'MaxTemp', header: 'MaxTemperature', type: 'number', inputProps: { inputProps: { step: 0.1 } }, width: 200, readOnly: [['Control', true]], decimal: true, disabled: true, inputWhen: ({ activeRecord }) => (!activeRecord.record.isError) },

		{ field: 'BIInTime', header: 'BIInTime', type: 'dateTime', utc: false, width: 200, readOnly: [['Control', true]], disabled: true, inputWhen: ({ activeRecord }) => (!activeRecord.record.isError) },
		{
			field: 'RunById', header: 'IncubatedBy', width: 200, lookup: 'User', required: [['isIncubated', true]], inputWhen: ({ activeRecord }) => (!activeRecord.record.isError), readOnly: ({ formik, activeRecord }) => {
				return Boolean(formik.values?.IsAcknowledge);
			}
		},
		{ field: 'BIReadTime', header: 'ReadTime', type: 'dateTime', width: 200, readOnly: [['Control', true]], disabled: true, inputWhen: ({ activeRecord }) => (!activeRecord.record.isError) },
		{ field: 'AcknowledgeTime', header: 'AcknowledgeTime', isLocal: true, type: 'dateTime', width: 200, readOnly: [['Control', true]], disabled: true, utc: false },
		{
			field: 'BIReadById', header: 'ReadById', width: 200, lookup: 'User', required: [['isNon', true]]
			, inputWhen: ({ activeRecord }) => (!activeRecord.record.isError), readOnly: [['isReadByDisable', true]]
		},
		{
			field: 'LotControlResult',
			type: 'number',
			width: 200, customizeInput: BiResultButtons,
			inputWhen: ({ formik }) => formik.values?.Control
		},
		{
			field: 'LotControlDate',
			header: 'Lot Control Date',
			type: 'dateTime',
			width: 200,
			readOnly: true,
			disabled: true,
			inputWhen: ({ formik }) => formik.values?.Control
		},
		// LotControlResult,LotControlDate For the changes has been done in 5.1 release
		// Sterilizer And Cycle Information Columns
		{
			field: 'SterilizerId', header: 'Sterilizer', width: 200, lookup: 'Sterilizer', required: [{ op: 'and', value: [['isError', false], ['Control', false]] }], inputSiblingComponents: [CyclesBtn], onChange: handleSterilizerChange
			, readOnly: ({ formik, activeRecord }) => {
				if (formik.values?.IsAcknowledge || formik.values?.Control || activeRecord.record?.SterilizerId) {
					return true;
				} else {
					return false
				}
			},
			inputWhen: ({ activeRecord }) => (!activeRecord.record.isError),
		},
		{
			field: 'SterilizerCycleTypeName', header: 'CycleType', type: 'string', width: 200,
			disabled: ({ formik, activeRecord }) => {
				if (activeRecord.record?.SterilizerId) {
					return true;
				}
				if (formik.values?.IsAcknowledge || formik.values?.Control || formik.values?.isfromProcessSterilizer) {
					return true;
				}
				const selectedSterilizer = activeRecord.combos.Sterilizer.find(item => formik.values.SterilizerId && item.LookupId === formik.values.SterilizerId);
				const connectivityType = selectedSterilizer?.ConnectivityType;
				return !!connectivityType;
			},
			required: [
				{
					field: 'SterilizerId',
					op: 'in',
					value: ({ activeRecord, values, formik }) => {
						const formValues = values || formik?.values
						const selectedSterilizer = activeRecord?.combos?.Sterilizer?.find(item => formValues?.SterilizerId && item.LookupId === formValues?.SterilizerId);
						return isNoneType.includes(selectedSterilizer?.EquipmentFamilyId) ? [formValues?.SterilizerId] : [];
					}
				}
			],
			minValue: 1,
			inputWhen: ({ activeRecord }) => (!activeRecord.record.isError),
			inputProps: {
				disableClearable: true
			},
		},
		{
			field: 'SterilizerCycleCount', header: 'CycleCount', type: 'number', width: 200,
			disabled: ({ formik, activeRecord }) => {
				if (activeRecord.record?.SterilizerId) {
					return true;
				}
				if (formik.values?.IsAcknowledge || formik.values?.Control || formik.values?.isfromProcessSterilizer) {
					return true;
				}
				const selectedSterilizer = activeRecord.combos.Sterilizer.find(item => formik.values.SterilizerId && item.LookupId === formik.values.SterilizerId);
				const connectivityType = selectedSterilizer?.ConnectivityType;
				return !!connectivityType;
			},
			required: [
				{
					field: 'SterilizerId',
					op: 'in',
					value: ({ activeRecord, values, formik }) => {
						const formValues = values || formik?.values
						const selectedSterilizer = activeRecord?.combos?.Sterilizer?.find(item => formValues?.SterilizerId && item.LookupId === formValues?.SterilizerId);
						return isNoneType.includes(selectedSterilizer?.EquipmentFamilyId) ? [formValues?.SterilizerId] : [];
					}
				}
			],
			minValue: 0,
			inputSiblingComponents: [SterilizerCycleinfoBtn],
			inputWhen: ({ activeRecord }) => (!activeRecord.record.isError)
		},

		// Chemical Indicator Columns
		{
			field: 'CILotNumberId', header: 'LotNumber', type: 'string', width: 200,
			columnSize: 6,
			addable: ({ activeRecord }) => {
				return `/lotdetaillist?id=new&returnTo=${encodeURIComponent(`/incubatorcycledetailform?id=${(activeRecord.record?.id || 0)}&incubatorCycleId=${activeRecord.record.IncubatorCycleId || 0}&isError=${activeRecord.record?.BIResult === consts.BIResult.Error}&isFromCycle=${activeRecord.record?.isFormCycleScreen}&returnTo=/equipmentinfo?id=${activeRecord.record?.IncubatorId}&name=${activeRecord.record.IncubatorName || ''}&isSterilizer=${false}&isIncubator=${true}&isFromEquipmentDetail=${true}&equipmentType=${activeRecord.record.EquipmentType}&equipmentTypeId=${activeRecord.record.EquipmentTypeId}&EquipmentId=${activeRecord.record?.IncubatorId}`)}`
			},
			editable: ({ formik, activeRecord }) => {
				return `/lotdetaillist?id=${formik.values.CILotNumberId}&returnTo=${encodeURIComponent(`/incubatorcycledetailform?id=${(activeRecord.record?.id || 'new')}&incubatorCycleId=${activeRecord.record.IncubatorCycleId}&isError=${activeRecord.record?.BIResult === consts.BIResult.Error}&isFromCycle=${activeRecord.record?.isFormCycleScreen}&returnTo=/equipmentinfo?id=${activeRecord.record?.IncubatorId}&name=${activeRecord.record.IncubatorName || ''}&isSterilizer=${false}&isIncubator=${true}&isFromEquipmentDetail=${true}&equipmentType=${activeRecord.record.EquipmentType}&equipmentTypeId=${activeRecord.record.EquipmentTypeId}&EquipmentId=${activeRecord.record?.IncubatorId}`)}`
			},
			lookup: 'CILotNumber',
			readOnly: isControlOrAcknowledged,
			disabled: isControlOrAcknowledged,
			inputWhen: ({ activeRecord }) => (!activeRecord.record.isError),
			onChange: handleLotNumberChange,
			inputProps: {
				clearOnBlur: true,
				disableClearable: true,
				renderOption: LotNumberOptions,
				renderInputProp: lotNumberRenderProps
			},
		},
		{ field: 'CIResult', header: 'CIResult', type: 'string', width: 200, customizeInput: CiResultButton, readOnly: [['Control', true]], disabled: validateAcknowledge, inputWhen: ({ activeRecord, formik }) => (!activeRecord.record.isError || !formik.values.Test) },
		{
			field: 'CIReadById', header: 'ReadById', width: 200, lookup: 'User',
			readOnly: isControlOrAcknowledged,
			inputWhen: ({ activeRecord, formik }) =>
				(!activeRecord.record.isError),

		},
	]
});

export default model.createFormDialog();
